export type PublicLocaleSegment = "en" | "fa";
export type AppLocale = "en-US" | "fa-IR";

export function getPublicLocaleSegment(pathname = window.location.pathname) {
  const segments = pathname.split("/").filter(Boolean);
  const segment = segments[0];

  return segments.length === 1 && (segment === "en" || segment === "fa")
    ? (segment as PublicLocaleSegment)
    : undefined;
}

export function getLocaleFromPublicPath(pathname = window.location.pathname) {
  const segment = getPublicLocaleSegment(pathname);

  if (segment === "en") {
    return "en-US";
  }

  if (segment === "fa") {
    return "fa-IR";
  }

  return undefined;
}

export function getInitialAppLocale() {
  return (
    getLocaleFromPublicPath() ||
    (import.meta.env.VITE_LANGUAGE === "en-US" ? "en-US" : "fa-IR")
  );
}

export function getDirectionFromLocale(locale: AppLocale) {
  return locale === "fa-IR" ? "rtl" : "ltr";
}
